module.exports = __webpack_public_path__ + "static/media/popular-products.7ccf3b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/popular-products.png
// module id = 2025
// module chunks = 0